
import { Routes } from '@angular/router';

import { AboutComponent } from './smartworld/smartworld.component';
import { ProjectsComponent } from './experience/experience.component';
import { EducationComponent } from './experience/education/education.component';
import { MindComponent } from './experience/mind/mind.component';
import { QadComponent } from './experience/qad/qad.component';
import { NiitComponent } from './experience/niit/niit.component';
import { ActivitiesComponent } from './4ir/4ir.component';
import { ArvrComponent } from './4ir/arvr/arvr.component';
import { IotComponent } from './4ir/iot/iot.component';
import { CloudComponent } from './4ir/cloud/cloud.component';
import { ConferencesComponent } from './4ir/conferences/conferences.component';
import { NetworkComponent } from './4ir/network/network.component';

export const routes: Routes = [
    { path: '', redirectTo: '/smartworld', pathMatch: 'full'},
    { path: 'smartworld', component: AboutComponent},
    { path: 'experience', component: ProjectsComponent},
    { path: '4ir', component: ActivitiesComponent},
    { path: 'experience/education', component: EducationComponent},
    { path: 'experience/mind', component: MindComponent},
    { path: 'experience/qad', component: QadComponent},
    { path: 'experience/niit', component: NiitComponent},
    { path: '4ir/iot', component: IotComponent},
    { path: '4ir/cloud', component: CloudComponent},
    { path: '4ir/arvr', component: ArvrComponent},
    { path: '4ir/conferences', component: ConferencesComponent},
    { path: '4ir/network', component: NetworkComponent},
];


